var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.286 0a1.857 1.857 0 011.745 2.498c3.78.752 6.612 3.918 6.612 7.716H.929c0-3.798 2.832-6.964 6.611-7.716A1.857 1.857 0 019.286 0zm9.285 13H0v-1.857h18.571V13zM9.286 4.179c-2.888 0-5.34 1.755-6.185 4.178H15.47c-.845-2.423-3.296-4.178-6.184-4.178z",
    fill: "currentcolor"
  })));
}

export default SvgBellIcon;